export default __webpack_public_path__ + "static/media/OrangeLogo.7d693402.svg";